import { defineSlotRecipe as o } from "@pandacss/dev";
import { anatomy as t } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/pin-input/dist/index.mjs";
const e = o({
  className: "pinInput",
  slots: t.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      fontFamily: "inter",
      gap: "1.5"
    },
    control: {
      gap: "3"
    },
    label: {
      fontFamily: "inter",
      marginBottom: "0px"
    },
    input: {}
  }
});
export {
  e as pinInput
};
